import React from 'react'
import { TableCell, TableRow } from '@material-ui/core';
import { formatCurrencyPesos } from '../../../../../../helpers/extraFunctions';

export const ItemsHiv = (props) => {
    const { item } = props;

    return (
        <TableRow>
            <TableCell align="left">{item?.idSolicitudPago}</TableCell>
            <TableCell align="left">{item?.solPagAnterior}</TableCell>
            <TableCell align="left">{item?.apellido_nombre}</TableCell>
            <TableCell align="left">{item?.cod_nom}</TableCell>
            <TableCell align="left">{item?.des_nom}</TableCell>
            <TableCell align="left">{item?.cant}</TableCell>
            <TableCell align="left">{item?.razonSocial}</TableCell>
            <TableCell align="left">{item?.expAnterior}</TableCell>
            <TableCell align="left">{item?.nroDeComprobante}</TableCell>
            <TableCell align="left">
                {item?.fechaComp ? new Date(item.fechaComp).toLocaleDateString('es-AR') : ''}
            </TableCell>
            <TableCell align="left">{`${formatCurrencyPesos(item?.impFact)}`}</TableCell>
    
        </TableRow>
    )
}

